module.exports = __webpack_public_path__ + "static/media/cameraText.1089914f.svg";